const s = "token", r = "language", c = "dataCenterDomain", l = "dataCenterType", n = "translation", S = () => localStorage.getItem(s) || "", m = (t) => localStorage.setItem(s, t), T = () => {
  localStorage.removeItem(s);
}, I = () => localStorage.getItem(r), i = (t) => localStorage.setItem(r, t), E = () => localStorage.getItem(c), N = (t) => localStorage.setItem(c, t), D = () => localStorage.getItem(l), y = (t) => localStorage.setItem(l, t), A = (t, e) => {
  const a = localStorage.getItem(n);
  if (a)
    try {
      const o = JSON.parse(a);
      o[t] = e, localStorage.setItem(n, JSON.stringify(o));
    } catch {
      const g = {
        [t]: e
      };
      localStorage.setItem(n, JSON.stringify(g));
    }
  else {
    const o = {
      [t]: e
    };
    localStorage.setItem(n, JSON.stringify(o));
  }
}, C = (t) => {
  const e = localStorage.getItem(n);
  if (e)
    try {
      return JSON.parse(e)[t] || null;
    } catch (a) {
      return console.error(a), null;
    }
};
export {
  A as addTranslation,
  E as getDataCenter,
  D as getDataCenterType,
  I as getLocalLanguage,
  S as getToken,
  C as getTranslation,
  T as removeToken,
  N as setDataCenter,
  y as setDataCenterType,
  i as setLocalLanguage,
  m as setToken
};
